import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const QuitSmokingPage = ({ language, setLanguage, t }) => {
  if (!t) return <div className="container">Error: Translations not loaded</div>;

  return (
    <div className="app-page-container">
      <div className="content-wrapper">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        
        <Link to="/" className="back-btn">
          <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {t.back || 'Back'}
        </Link>

        <div className="app-hero">
          <div className="app-icon-section">
            <img
              src="/images/smoking.png"
              alt="QuitSmoking"
              className="app-hero-icon"
              onError={(e) => { e.target.src = '/images/fallback.png'; }}
            />
            <div className="app-info">
              <h1 className="app-title">{t.quitSmokingTitle || 'QuitSmoking'}</h1>
              <div className="app-rating">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
                <span className="rating-text">4.8</span>
              </div>
              <p className="app-subtitle">{t.quitSmokingTagline || 'Quit smoking with Sunny'}</p>
            </div>
          </div>
          
          <div className="download-section">
            <a href="https://apps.apple.com/app/quitsmoking/id1234567891" className="download-button ios">
              <div className="download-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
              </div>
              <div className="download-text">
                <span className="download-label">Download on the</span>
                <span className="download-store">App Store</span>
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.quitsmoking.app" className="download-button android">
              <div className="download-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
              </div>
              <div className="download-text">
                <span className="download-label">Get it on</span>
                <span className="download-store">Google Play</span>
              </div>
            </a>
          </div>
        </div>

        <div className="app-main-content">
          <div className="about-section">
            <h2 className="section-title">{t.aboutTitle || 'About QuitSmoking'}</h2>
            <div className="about-text">
              <p>{t.aboutText1 || 'QuitSmoking helps you quit smoking with personalized AI coaching and proven techniques.'}</p>
              <p>{t.aboutText2 || 'Track your progress, stay motivated with daily challenges, and join a supportive community.'}</p>
              <p>{t.aboutText3 || 'Join thousands who have successfully quit with QuitSmoking!'}</p>
            </div>
            
            <div className="features-showcase">
              {[
                { icon: '🤖', title: t.features?.aiCoach || 'AI Coach', desc: 'Personal guidance 24/7' },
                { icon: '📊', title: t.features?.tracking || 'Progress Tracking', desc: 'See your improvement' },
                { icon: '🎯', title: t.features?.challenges || 'Daily Challenges', desc: 'Stay motivated daily' },
                { icon: '👥', title: t.features?.community || 'Community Support', desc: 'Connect with others' },
              ].map((feature, i) => (
                <div key={i} className="feature-showcase-card">
                  <div className="feature-showcase-icon">{feature.icon}</div>
                  <h3 className="feature-showcase-title">{feature.title}</h3>
                  <p className="feature-showcase-desc">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <footer className="app-footer">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">{t.ourApps || 'Home'}</Link>
              <Link to="/quitsnus">{t.quitSnusTitle || 'QuitSnus'}</Link>
              <Link to="/mrpiggy">{t.mrPiggyTitle || 'Mr Piggy'}</Link>
              <Link to="/nero-diamante">{t.neroDiamanteTitle || 'Nero Diamante'}</Link>
            </div>
            <div className="footer-legal">
              <Link to="/quitsmoking-privacy">{t.privacyPolicy || 'Privacy Policy'}</Link>
              <Link to="/quitsmoking-terms">{t.termsOfUse || 'Terms of Service'}</Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default QuitSmokingPage;